/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Layers, SerialLayers} from "../../view/SerialLayers";
import {Serial} from "../../Serial";
import {Translation} from "../../../core/utils/Translation";
import {SerialSound} from "../../sound/SerialSound";

export class WinCapEndScreen extends ContinueScreen {

    private _winImage:PIXI.Sprite;

    constructor() {
        super(SerialLayers.getLayer(Layers.SCREENS)!);

        this._winImage = new PIXI.Sprite(Serial.assetLoader.getTextures("X_bizarre_cap_win")[0]);
        this._winImage.anchor.set(0.5);
        this._winImage.position.set(360, 360);
        this._container.addChild(this._winImage);
    }

    public show(onContinueCallBack:() => void) {
        Serial.jumpingScatterController.finish();
        this._winImage.visible = Serial.model.parsedGameData.maximumWinAchieved;
        Serial.screenCountUp.y = 490;

        SerialSound.PLAYING_LOOP_EFFECT = "";
        for(let i = 0; i < 3; i++) {
            SerialSound.soundPlayer.stopTrack(SerialSound.WIN_CAP_LOOP[i]);
        }
        if(Serial.model.parsedGameData.maximumWinAchieved) {
            SerialSound.soundPlayer.playTrack({name : SerialSound.WIN_CAP_LOOP[3], repeat : 1000});
            SerialSound.PLAYING_LOOP_EFFECT = SerialSound.WIN_CAP_LOOP[3];
            SerialSound.soundPlayer.playTrack({name : SerialSound.WIN_CAP_MAX_WIN});
        }

        // To make sure the main music always start from the beginning.
        SerialSound.switchMusic({
            name : SerialSound.FREESPIN_MUSIC,
            volume : 0
        });

        super.show(onContinueCallBack);
    }

    protected close():TimelineLite {
        const tl = super.close();
        tl.add(() => {
            SerialSound.soundPlayer.playTrack({name : SerialSound.CONTINUE_FS_OUTRO});
            this.startNormalMusic();
            Serial.winCapController.close();
        }, 0);
        return tl;
    }

    private startNormalMusic():void {
        SerialSound.PLAYING_LOOP_EFFECT = "";
        SerialSound.soundPlayer.stopTrack(SerialSound.WIN_CAP_LOOP[3]);
        SerialSound.switchMusic({
            name : SerialSound.MAIN_GAME_MUSIC,
            volume : 1
        });
        SerialSound.fadeMusic(1, 1);
    }
}